import { render, staticRenderFns } from "./AssetPoolFieldMapper.vue?vue&type=template&id=583f97ca&scoped=true&"
import script from "./AssetPoolFieldMapper.vue?vue&type=script&lang=js&"
export * from "./AssetPoolFieldMapper.vue?vue&type=script&lang=js&"
import style0 from "./AssetPoolFieldMapper.vue?vue&type=style&index=0&id=583f97ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583f97ca",
  null
  
)

export default component.exports